import mapboxgl from "mapbox-gl";

import defaultStyles from "fond/draw/defaultStyles";
import { MapboxStyleLayer } from "fond/types";

/**
 * The MapboxDraw theme extended to include styles specific for planner projects
 * when drawing underground features.
 */
const modifiedDefaults: MapboxStyleLayer[] = defaultStyles.map((style) => {
  // Override the line styles to include hover effects
  if (style.id === "gl-draw-line-inactive") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "line-color": ["case", ["==", ["get", "user_meta:hover"], "true"], "#1489EF", "#ffb265"],
      },
    } as mapboxgl.LineLayer;
  }

  if (style.id === "gl-draw-line-active") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "line-dasharray": [1],
        "line-width": 3,
        "line-color": "#FF5832",
      },
    } as mapboxgl.LineLayer;
  }

  // Override the color of the vertex & mid point colors
  if (
    [
      "gl-draw-point-active",
      "gl-draw-polygon-midpoint",
      "gl-draw-polygon-and-line-vertex-inactive",
      "gl-draw-polygon-and-line-vertex-stroke-inactive",
    ].includes(style.id)
  ) {
    return {
      ...style,
      paint: {
        ...style.paint,
        "circle-color": "#FF5832",
      },
    } as mapboxgl.CircleLayer;
  }

  return style;
});

export default modifiedDefaults;
